import { Colors } from '../../../themes/colors';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

export const routineMessageStyles = themedStyleSheet((role) => ({
  container: {
    width: '100%',
    flexDirection: 'column',
  },
  messageTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: role.textSecondary,
  },
  questionContainer: {
    marginVertical: 5,
    borderRadius: 8,
    padding: 12,
  },
  exceptionsContainer: {
    backgroundColor: Colors.redBackground,
  },
  noExceptionsContainer: {
    backgroundColor: role.surfaceHover,
  },
  isEdited: {
    backgroundColor: Colors.primaryLight,
    borderWidth: 1,
    borderColor: Colors.primary,
  },
  isEditedText: {
    color: Colors.primary,
  },
  questionLabel: {
    color: role.textSecondary,
  },
  questionLabelException: {
    color: Colors.redText,
  },
  text: {
    color: role.textSecondary,
  },
  textException: {
    color: Colors.redText,
  },
}));
